export default __webpack_public_path__ + "static/media/prominio-landing-page-icon.e83b37fc.svg";